import { datadogLogs } from "@datadog/browser-logs";
import { logsConfig } from "providers/datadog/config";

const getError = (context: unknown) => {
  if (context instanceof Error) return context;

  if (
    typeof context === "object" &&
    context !== null &&
    "error" in context &&
    context.error instanceof Error
  )
    return context.error;

  return null;
};

const safeStringify = (value: unknown): string => {
  if (typeof value === "string") return value;
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
};

class DatadogLogger {
  private static instance: DatadogLogger;

  private constructor() {
    if (!datadogLogs.getInitConfiguration()) datadogLogs.init(logsConfig);
  }

  static getInstance(): DatadogLogger {
    if (!DatadogLogger.instance) DatadogLogger.instance = new DatadogLogger();

    return DatadogLogger.instance;
  }

  info(message: string, context?: unknown) {
    datadogLogs.logger.info(
      message,
      context
        ? {
            payload: context
          }
        : undefined
    );
  }

  warn(message: string, context?: unknown) {
    datadogLogs.logger.warn(
      message,
      context
        ? {
            payload: context
          }
        : undefined
    );
  }

  error(message: string, context?: unknown) {
    const actualError = getError(context);

    const errorInstance = actualError || new Error(safeStringify(context));

    const errorContext = {
      payload: {
        ...(typeof context === "object" &&
        context !== null &&
        !(context instanceof Error)
          ? context
          : {}),
        errorName: errorInstance.name,
        errorMessage: errorInstance.message,
        errorStack: errorInstance.stack,
        errorCause: errorInstance.cause
      }
    };

    datadogLogs.logger.error(message, errorContext, errorInstance);
  }
}

export const logger = DatadogLogger.getInstance();
